import { useContext } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router'

// 🛑 WARNING: This is not bullet proof! Use with caution.
// Only for non critical stuff!
// Distinguishes hash vs browser routers by the underlying navigator's own createHref format
// (hash history always prefixes with '#', browser history never does), instead of
// location.key: react-router-v5-compat's <Router> always normalizes an undefined key to
// "default", so key-based detection can't tell the two apart once compat is in the tree.
export const useRouterTypeDetection = () => {
  const { navigator } = useContext(NavigationContext)
  const isHashRouter = navigator.createHref({ pathname: '/', search: '', hash: '' }).startsWith('#')

  return {
    isHashRouter,
    isBrowserRouter: !isHashRouter,
  }
}
